import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {HeaderFilter} from 'asax-common';
import {DropdownItem, DropdownSearchInput} from "../search-input.model";


@Component({
  selector: 'asax-header-search-input-dropdown',
  templateUrl: './search-input-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`.border-radius-right-0 {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }`]
})
export class SearchInputDropdownComponent implements OnInit, OnChanges {
  @Input() searchInput: DropdownSearchInput;

  @Output() outFilter = new EventEmitter<HeaderFilter>();

  valueToDisplay: string;
  valueSubject = new Subject<string>();

  ngOnInit(): void {
    this.valueSubject.asObservable().pipe(
      tap(() => this.buildValue()),
      tap(() => this.buildValueToDisplay()),
      tap(() => this.emitFilter())
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectDropdownItemsFromValue();
    this.valueChanged();
  }

  valueChanged(): void {
    this.valueSubject.next(undefined);
  }

  onDropdownItemClick(dropdownItem: DropdownItem) {
    dropdownItem.selected = !dropdownItem.selected;
    this.valueChanged();
  }

  clearSearchInputValue(): void {
    this.searchInput.dropdownItems.forEach(dropdownItem => dropdownItem.selected = false);
    this.valueChanged();
  }

  private buildValue(): void {
    this.searchInput.value = this.searchInput.dropdownItems
      .filter(({selected}) => !!selected)
      .map(({value}) => value)
      .join(',');
  }

  private buildValueToDisplay(): void {
    this.valueToDisplay = this.searchInput.dropdownItems
      .filter(({selected}) => !!selected)
      .map(({text}) => text)
      .join(', ');
  }

  private selectDropdownItemsFromValue(): void {
    const dropdownItemsSelected: string[] = this.searchInput?.value?.split(',').map(token => token.trim());
    this.searchInput?.dropdownItems?.forEach(dropdownItem => {
        if (dropdownItemsSelected?.includes(dropdownItem.value)) {
          dropdownItem.selected = true;
        } else {
          dropdownItem.selected = false;
        }
      }
    );
  }

  private emitFilter(): void {
    const filter = {
      id: this.searchInput.id,
      value: this.searchInput?.value,
      valueParsed: this.searchInput?.value,
      valueToDisplay: this.valueToDisplay,
      label: this.searchInput.label,
      isDisabled: this.searchInput?.isDisabled,
      elasticParserType: this.searchInput.elasticParserType
    };

    this.outFilter.emit(filter);
  }
}
